import Hero from "./Hero";
import About from "./About";
import Classes from "./Classes";
import Schedule from "./Schedule";
import Instructors from "./Instructors";
import Contact from "./Contact";
import ReturningMembers from "./ReturningMembers";

const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <Classes />
      <Schedule />
      <Instructors />
      <Contact />
      <ReturningMembers />
    </>
  );
};

export default Home;